import _ from "lodash";

/**
 * Decide se um item de menu está contratado, olhando o plano da contabilidade.
 *
 * Vive fora do `navigation.service.js` porque aquele arquivo importa o `angular` e só roda no
 * browser; aqui a regra é pura e testável. Muta `navItem.contracted`, que é o que o `ng-if`
 * mestre da `sidebar-navigation` lê.
 *
 * Quatro caminhos, nesta ordem:
 * 1. `accountingPlan.hiddenWhenFeatures` — o item existe SÓ para quem NÃO contratou (gate
 *    inverso). Hoje NENHUM item do `navigation.config.js` usa este caminho: a Carteira, que era
 *    o único, passou a aparecer nos dois mundos. Fica porque é o inverso natural do
 *    `requiredFeatures` e volta a valer no primeiro item que precisar sumir para quem tem o
 *    Agente Consultivo — o v2 mantém o `withoutConsultive` pela mesma razão;
 * 2. `accountingPlan.requiredFeatures` — exige TODAS as features da lista (E);
 * 3. `accountingPlan.features` / `accountingPlan.module` — a regra antiga, que é OU;
 * 4. sem `accountingPlan` — sempre visível.
 */
export function applyPlanContract(navItem, accountingPlanEntity) {
    const plan = navItem.accountingPlan;
    const _isEmpty = (path) =>
        typeof _.get(navItem, `accountingPlan.${path}`) === "undefined";

    if (
        _.get(plan, "hiddenWhenFeatures.length") &&
        accountingPlanEntity.isContractedFeatures({
            values: plan.hiddenWhenFeatures
        })
    )
        return (navItem.contracted = false);

    if (
        _.get(plan, "requiredFeatures.length") &&
        !plan.requiredFeatures.every((value) =>
            accountingPlanEntity.isContractedFeature({ value })
        )
    )
        return (navItem.contracted = false);

    if (_isEmpty("features") && _isEmpty("module.name"))
        return (navItem.contracted = true);

    const isContractedModule = plan?.module?.source
        ? accountingPlanEntity.isContractedModule({
              value: plan?.module?.name,
              source: plan?.module?.source
          })
        : accountingPlanEntity.isContractedModuleByValue({
              value: plan?.module?.name
          });

    // `Boolean` porque `isContractedModuleByValue` devolve `undefined` quando o item não
    // declara módulo — e `contracted: undefined` é indistinguível de "nunca foi avaliado".
    return (navItem.contracted = Boolean(
        accountingPlanEntity.isContractedFeatures({
            values: plan?.features
        }) || isContractedModule
    ));
}
